import React from 'react';
import { Row, Col, Select, Input, Checkbox, Card, Button, Space } from 'antd';

const ParticipantsFilters = ({
                                 events,
                                 participantStates,
                                 participantTypes,
                                 programmePoints,
                                 filters,
                                 setFilters,
                                 onEventChange,
                                 onSearchParticipants,
                                 onSearchLeads
                             }) => (
    <Row gutter={[16, 16]} align="stretch">
        {/* Card Principal */}
        <Col xs={24} md={24} style={{ display: 'flex' }}>
            <Card
                title="Participant Search"
                bordered
                style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                bodyStyle={{ display: 'flex', flexDirection: 'column', flex: 1 }}
            >
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    {/* Parte superior con los filtros */}
                    <Space direction="vertical" style={{ width: '100%' }} size="middle">
                        <Row gutter={[16, 16]} align="middle">
                            <Col xs={24} sm={12} md={8}>
                                <Select
                                    placeholder="Select Event"
                                    style={{ width: '100%' }}
                                    value={filters.eventPK}
                                    onChange={onEventChange}
                                >
                                    {events.map(event => (
                                        <Select.Option key={event._id} value={event.eventId}>
                                            {event.name[0]?.value || event.mnemonic}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Input
                                    placeholder="First Name"
                                    value={filters.firstName}
                                    onChange={e =>
                                        setFilters(prev => ({ ...prev, firstName: e.target.value }))
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12}  md={8}>
                                <Input
                                    placeholder="Last Name"
                                    value={filters.lastName}
                                    onChange={e =>
                                        setFilters(prev => ({ ...prev, lastName: e.target.value }))
                                    }
                                />
                            </Col>

                        </Row>

                        <Row gutter={[16, 16]} align="middle">
                            <Col xs={24} sm={12} md={8}>
                                <Checkbox
                                    checked={filters.hasRegistration}
                                    onChange={e =>
                                        setFilters(prev => ({ ...prev, hasRegistration: e.target.checked }))
                                    }
                                >
                                    Has Registration
                                </Checkbox>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Checkbox
                                    checked={filters.hasBadge_Enabled}
                                    onChange={e =>
                                        setFilters(prev => ({ ...prev, hasBadge_Enabled: e.target.checked }))
                                    }
                                >
                                    Has Badge (Enabled)
                                </Checkbox>
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]} align="middle">
                            <Col xs={24} sm={12}  md={8}>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    placeholder="Participant Type(s)"
                                    style={{ width: '100%' }}
                                    value={filters.participantTypes}
                                    onChange={values =>
                                        setFilters(prev => ({ ...prev, participantTypes: values }))
                                    }
                                    maxTagCount="responsive"
                                    options={participantTypes.map(type => ({
                                        value: type.id,
                                        label: type.name?.[0]?.value || type.id
                                    }))}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    placeholder="Participant State(s)"
                                    style={{ width: '100%' }}
                                    value={filters.participantStatePKs}
                                    onChange={values =>
                                        setFilters(prev => ({ ...prev, participantStatePKs: values }))
                                    }
                                    maxTagCount="responsive"
                                    options={participantStates.map(state => ({
                                        value: state.id,
                                        label: state.name?.[0]?.value || state.id
                                    }))}
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    placeholder="Has Lead for Programme Point(s)"
                                    style={{ width: '100%' }}
                                    value={filters.programmePointIds}
                                    onChange={values =>
                                        setFilters(prev => ({ ...prev, programmePointIds: values }))
                                    }
                                    maxTagCount="responsive"
                                    options={(programmePoints || []).map(pp => ({
                                        value: pp.id,
                                        label: pp.name?.[0]?.value || pp.id
                                    }))}
                                />
                            </Col>
                        </Row>
                    </Space>

                    <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
                        <Button type="primary" onClick={onSearchParticipants}>
                            🔍 Search Participants
                        </Button>
                    </div>
                </div>
            </Card>
        </Col>
    </Row>
);

export default ParticipantsFilters;